<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="d-sm-none"
           for="name{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.INFLUENCER.PLATTFORMEN.NAME' | translate }}</label>
    <div class="col-sm-6">
      <input class="form-control" datevMessagePath="name{{objectId}}" formControlName="name"
             id="name{{index}}" type="text"
             utilsCheckValidity utilsControlState
             utilsMarkRequired utilsValidationMessage/>
    </div>

    <label class="d-sm-none"
           for="accountName{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.INFLUENCER.PLATTFORMEN.ACCOUNT_NAME' | translate }}</label>
    <div class="col-sm-6 position-relative">
      <input class="form-control" datevMessagePath="accountName{{objectId}}" formControlName="accountName"
             id="accountName{{index}}" type="text"
             utilsCheckValidity
             utilsControlState utilsValidationMessage/>
      <div class="common-ui-remove-plattform-button">
        <button (click)="removePlattform()" *ngIf="!readonly"
                class="btn btn-light btn-img" id="plattformEntfernen{{index}}"
                title="{{'COMMON_UI.FRAGEBOGEN.INFLUENCER.REMOVE_PLATTFORM' | translate }}"
                type="button">
          <em class="icon icon-svg icon-fi-loeschen"></em>
        </button>
      </div>
    </div>

  </div>

</form>

